// declare var readImageUrl: (input: HTMLInputElement) => void

import { readImageUrl } from '@/javascript/legacy/image-helper'

type Props = {
  values: {
    title: string
    description: string
    details: string
  }
  image?: File
}

export const fillLegacyTicketForm = ({ values, image }: Props) => {
  const titleEl = document.querySelector<HTMLTextAreaElement>('#ticket_title')
  const descriptionEl = document.querySelector<HTMLTextAreaElement>('#ticket_description')
  const detailsEl = document.querySelector<HTMLTextAreaElement>('#ticket_details')
  const attachmentEl = document.querySelector<HTMLInputElement>('input[name="ticket[attachments_attributes][0][file]"]')
  const hasValues = titleEl.value || descriptionEl.value || detailsEl.value || attachmentEl.files.length > 0
  if (hasValues && !confirm('O conteúdo dos campos preenchidos será alterado ao utilizar a IA.\n\nDeseja continuar?')) return
  titleEl!.value = values.title
  descriptionEl!.value = values.description
  detailsEl!.value = values.details
  if (image) {
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(image)
    attachmentEl!.files = dataTransfer.files
  } else {
    attachmentEl!.files = new DataTransfer().files
    const preview = document.querySelector<HTMLImageElement>('#prev_image')
    preview!.src = ''
  }
  readImageUrl(attachmentEl!)
}
